import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import axios from "axios";

const Category = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [categories, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [filterText, setFilterText] = useState("");
  const history = useHistory();

  const fetchCategory = async () => {
    try {
      const response = await api.post(`/category/get`);
      if (response.data.success) {
        setCategory(response.data.category);
      } else {
        setError("Category not found");
      }
    } catch (err) {
      setError("Error fetching Category details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const filteredItems = categories.filter((item) =>
    item.name.toLowerCase().includes(filterText.toLowerCase()),
  );

  const deleteCategory = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/category/delete/${id}`);
      if (response) {
        fetchCategory();
        toast.success("Product Delete Success");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const addCategory = async (e) => {
    try {
      e.preventDefault();
      localStorage.setItem("category-list", null);
      history.push("add-edit-category");
    } catch (error) {
      console.log(error);
    }
  };

  const editCategory = async (e, row) => {
    try {
      e.preventDefault();
      localStorage.setItem("category-list", JSON.stringify(row));
      history.push("add-edit-category");
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
      width: "140px",
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}/${row.image}`}
          alt={row.name}
          width="80"
          height="50"
          style={{ borderRadius: "8px" }}
        />
      ),
      width: "220px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "280px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button className="btn btn-lg" onClick={(e) => editCategory(e, row)}>
            <i className="icon-edit-3"></i>
          </button>
          <button
            className="btn btn-lg"
            onClick={(e) => deleteCategory(e, row.id)}
          >
            <i className="icon-trash-2"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>Categories List</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/dashboard">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Categories List</div>
              </li>
            </ul>
          </div>
          {/* <!-- product-list --> */}
          <div className="wg-box">
            <div className="flex justify-end">
              <Link
                className="tf-button style-1 w208"
                onClick={(e) => addCategory(e)}
                style={{
                  textDecoration: "none",
                }}
              >
                <i className="icon-plus"></i>Add new
              </Link>
            </div>

            {error && <p className="text-danger">{error}</p>}

            {/* Search Input */}
            <div className="datatable-container col-md-8">
              <div className="datatable-header">
                <input
                  type="text"
                  placeholder="Search product..."
                  className="datatable-search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
                {filterText && (
                  <button
                    className="datatable-clear"
                    onClick={() => setFilterText("")}
                  >
                    ✕
                  </button>
                )}
              </div>
              <DataTable
                columns={columns}
                data={filteredItems}
                progressPending={loading}
                pagination
                highlightOnHover
                striped
                responsive
                defaultSortField="name"
              />
              <div className="divider"></div>
            </div>
            {/* <!-- /product-list --> */}
          </div>
          {/* <!-- /main-content-wrap --> */}
        </div>
      </div>
    </>
  );
};
export default Category;
